import React, { useState, useEffect, useContext, useRef } from "react";
import { store, ASSETS_URL } from "../../Store";
import { FocusScope } from "react-aria";

import { Icon } from "@iconify/react/dist/iconify.js";
import { useTranslations } from "../../../hooks/use-translations";
import useIsMobile from "../../../js/utilities/useIsMobile";
import { useGeneralHeaderDropdown } from "../../../hooks/header/useGeneralHeaderDropdown";

import { NavbarBrand } from "../components/NavbarBrand";
import { NavbarNav } from "./components/NavbarNav";
import { SkeletonHeader } from "./components/SkeletonHeader";
import { DropdownMiCuenta } from "./components/DropdownMiCuenta";
import { BookDownloadingPopUp } from "../../book-downloading-popup";
import { LangButton } from "../../language/lang-button";
import { useAdvancedSearch } from "../../../hooks/advanced-search/use-advanced-search";
import { useLanguage } from "../../../hooks/use-language";
import { useId } from "../../../hooks/use-id";

/**
 * Componente del header institucional
 * @returns {JSX.Element} - GeneralHeader
 */
export const GeneralHeader = () => {
  const lang = useLanguage();
  const textosInterfaz = useTranslations({ section: "header", lang: lang, array: true });

  const globalState = useContext(store);
  const { state } = globalState;
  const isMobile = useIsMobile();
  const isLogged = state.sesionActiva !== null && state.sesionActiva === "SI";
  const [isLoading, setIsLoading] = useState(true);

  const showADropdown = useGeneralHeaderDropdown();
  const dropdownButtonRef = useRef(null);

  const advancedSearch = useAdvancedSearch();
  const advancedSearchButtonResRef = useRef(null);
  const [renderizado, setRenderizado] = useState(0);

  const menuId = useId("user-menu");

  /*Asigna el botón que abre las opciones de búsqueda */
  useEffect(() => {
    if (renderizado === 0) {
      setRenderizado(renderizado.current + 1);
      return;
    }
    if (advancedSearchButtonResRef.current && isMobile) {
      globalState.dispatch({
        type: "CHANGE",
        path: "advancedSearch.triggerButton",
        value: advancedSearchButtonResRef,
      });
    }
  }, [advancedSearchButtonResRef, renderizado, isMobile]);


  useEffect(() => {
    if (dropdownButtonRef.current) {
      globalState.dispatch({
        type: "CHANGE",
        path: "generalHeaderDropdown.triggerButtonRef",
        value: dropdownButtonRef,
      });
    }
  }, [dropdownButtonRef.current]);

  useEffect(() => {
    if (state?.datosHeader) {
      setIsLoading(false);
    }
  }, [state?.datosHeader]);

  return (
    <>
      {isLoading ?
        <div role="status" aria-live="polite">
          <span className="sr-only">{textosInterfaz?.general_header_title_load || "Cargando encabezado"}</span>
          <SkeletonHeader />
        </div>
        :
        <div className="general-header">
          <nav className="h-100 row mx-0" aria-label={textosInterfaz?.general_header_title || "Navegación principal xx"}>
            <div className="col-5 col-lg-6 px-0 d-flex" style={{ height: 65 }}>
              <NavbarBrand textosInterfaz={textosInterfaz} />
            </div>

            {!isMobile &&
              <div className="col-lg-6 px-2">
                <NavbarNav textosInterfaz={textosInterfaz} />
              </div>
            }

            {isMobile &&
              <div className="col-7 col-lg-6 px-0 d-flex justify-content-end align-items-center">
                <div className=" d-flex align-items-center mx-2">
                  <button
                    ref={advancedSearchButtonResRef}
                    className={`btn-libros  focusable-red ${advancedSearch?.state?.visible ? "activeButton" : ""}`}
                    onClick={() => {
                      advancedSearch.setVisible(!advancedSearch?.state?.visible);
                    }}
                    aria-expanded={advancedSearch?.state?.visible}
                    aria-label={textosInterfaz?.general_header_buttons_books ||  "Abrir búsqueda avanzada de libros"}
                  >
                    {textosInterfaz?.libros || 'Libros'}
                    <Icon icon="material-symbols:keyboard-arrow-down-rounded" className="icon-down" />
                  </button>
                </div>

                <div className="d-flex align-items-center line-cuenta">
                  <button
                    ref={dropdownButtonRef}
                    className={`btn-cuenta focusable-red mr-2 ${showADropdown?.state?.visible ? "activeButton" : ""}`}
                    onClick={() => {
                      showADropdown.setVisible(!showADropdown?.state?.visible)
                    }}
                    aria-haspopup="menu"
                    aria-expanded={showADropdown?.state?.visible}
                    aria-controls={menuId}
                    aria-label={textosInterfaz?.general_header_buttons_account ||  "Abrir menú de usuario"}
                  >
                    <div
                      className=" btn-avatar"
                      style={
                        { backgroundImage: `url('${isLogged ? `${ASSETS_URL}${state.datosHeader?.avatar}` : '/img/profile.png'}')` }
                      }
                    ></div>
                    <Icon icon="material-symbols:keyboard-arrow-down-rounded" className="icon-down" />
                  </button>
                </div>

                <div className=" d-flex align-items-center mx-2">
                  <LangButton />
                </div>
              </div>
            }

          </nav>

          {isMobile &&
            <DropdownMiCuenta textosInterfaz={textosInterfaz}/>
          }

          {
            state.descargando &&
            <FocusScope contain>
              <BookDownloadingPopUp />
            </FocusScope>
          }
        </div>
      }
    </>
  )
}